﻿import axios, { ResponseType } from "axios";

const userService =
{    
    getDatosDinamicos: async (conDeuda:boolean): Promise<any> =>
    {
        try {
            const response = await axios.get(process.env.REACT_APP_API_URL + '/api/User/getDatosDinamicos/' + conDeuda.toString());
            return response.data;

        } catch (error: any) {
            console.log("Error ", error.response ? error.response.data : error.message);
            //throw error.response ? error.response.data : error.message;
        }   
    },
    getDatosUtiles: async (LegajoPrevisional: string) => {
        try {            
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/api/User/getdatosutiles/` + LegajoPrevisional                
            );
            return response.data;
        } catch (error: any) {
            throw error.response ? error.response.data : error.message;
        }
    },
    getBeneficios: async () => {
        try {            
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/User/getBeneficios`);
            return response.data;

        } catch (error: any) {
            throw error.response ? error.response.data : error.message;
        }
    },

    getProfilePicture: async (idAfiliado: string) => {
        try {
            let type: ResponseType = 'arraybuffer';
            
            const config = {               
                responseType: type,
            };

            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/api/User/getProfilePicture/` + idAfiliado,
                config
            );

            return response.data;

        } catch (error: any) {
            if (error.response) {
                // Si la respuesta tiene un error, manejamos el 404 específicamente
                if (error.response.status === 404) {
                    // Aquí puedes manejar específicamente el error 404
                    console.log('No se encontró la imagen del perfil.');
                    return null; // o alguna acción específica cuando no se encuentre la imagen
                }
            }
        }
    },
    getHistorialMatricula: async (LegajoPrevisional: string) => {
        try {            
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/api/User/gethistorialmatricula/` + LegajoPrevisional                
            );
            return response.data;
        } catch (error: any) {
            throw error.response ? error.response.data : error.message;
        }
    },
    bajarCuenta: async () => {
        try {           
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/api/User/deactivateAccount`, null                
            );
            return response.data;

        } catch (error: any) {
            throw error.response ? error.response.data : error.message;
        }
    },

    uploadImage: async (afiId: string, file: File): Promise<any> => {
        try {
            const formData = new FormData();
            formData.append("afi_id", afiId);
            formData.append("FileType", file.type);
            formData.append("File", file);

            const response = await axios.post(
                process.env.REACT_APP_API_URL + "/api/Account/uploadImage",
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            return response.data;
        } catch (error: any) {
            throw error.response ? error.response.data : error.message;
        }
    },
};


export default userService
